import { VaultStatus } from './enums/vault-status.enum';

export interface IVfAppMarketApp {
  acquirerApp: {
    isFeatured?: boolean;
    isPilot?: boolean;
    isPublic?: boolean;
    isDefault?: boolean;
  };
  acquirerIsDefault: boolean;
  appId: string;
  appVersionId: string;
  appName: string;
  appVersion: string;
  pricingModelId: string;
  pricingModel: string;
  price: number;
  appcatalogAppStatus: string;
  appcatalogIsDefaultApp: boolean;
  appmarketAppId: string;
  acquirers: IAcquirer[];
  modelFamilies?: string[];
  modelFamiliesWithDeviceModels?: {
    [modelFamilyValue: string]: string[];
  };
  categories?: string[];
  isFeatured: boolean;
  isPublic?: boolean;
  isPilot?: boolean;
  isDefault?: boolean;
  isDefaultApp: boolean;
  isAvailableForUpgrade?: boolean;
  hasAssignments?: boolean;
  acquirerBundleIsDefault: boolean;
}
export interface IAcquirer {
  acquirerAppStatus?: string;
  acquirerEntityUid?: string;
  merchantEntityUids?: string[];
  appPackageStatus?: string;
  appPackageUninstallStatus?: string;
  marketplaceManagerAppStatus?: string;
  isFeatured?: boolean;
  isPilot?: boolean;
  isPublic?: boolean;
  isDefault?: boolean;
  vaultStatus?: VaultStatus;
}
